export default "__VITE_PUBLIC_ASSET__01d10bae__"